import React from "react";
import styles from "./Privacy.module.scss";

const PrivacyPolicy = () => {
  return (
    <div className={styles.privacyPolicy}>
      <h1 className={styles.title}>Privacy Policy</h1>

      <section className={styles.section}>
        <h2>1. Introduction</h2>
        <p>
          At Sealkloud Business Solutions, we highly value the protection of our
          visitors' and customers' personal data. This privacy policy details
          the personal data collected, used, and shared during the provision of
          services by Sealkloud Business Solutions and explains how your data is
          protected and what your rights are.
        </p>
      </section>

      <section className={styles.section}>
        <h2>2. Collection and Use of Personal Data</h2>
        <p>
          When you visit our website or use our services, we may collect
          personal data such as your name, email address, and telephone number.
          We also collect web usage data through cookies to improve our business
          processes.
        </p>
        <p>This data is used for the following purposes:</p>
        <ul className={styles.list}>
          <li>To provide our services to you,</li>
          <li>To enhance user experience,</li>
          <li>To provide technical support or customer service,</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>3. Data Sharing and Disclosure</h2>
        <p>
          Your personal data is only shared with our business partners and legal
          authorities as necessary for our services and within the bounds of
          legal requirements. Any sharing of data with third parties is
          conducted in a manner that guarantees the protection of your privacy.
        </p>
      </section>

      <section className={styles.section}>
        <h2>4. Data Security</h2>
        <p>
          Your personal data is protected against loss, misuse, and unauthorized
          access. We have implemented appropriate technical and administrative
          measures to ensure data security.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
